import { render, staticRenderFns } from "./TextMap.vue?vue&type=template&id=ffff51f0&scoped=true"
import script from "./TextMap.vue?vue&type=script&lang=js"
export * from "./TextMap.vue?vue&type=script&lang=js"
import style0 from "./TextMap.vue?vue&type=style&index=0&id=ffff51f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffff51f0",
  null
  
)

export default component.exports